import { render, staticRenderFns } from "./planShare.vue?vue&type=template&id=97d7a8ac&scoped=true&"
import script from "./planShare.vue?vue&type=script&lang=ts&"
export * from "./planShare.vue?vue&type=script&lang=ts&"
import style0 from "./planShare.vue?vue&type=style&index=0&id=97d7a8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d7a8ac",
  null
  
)

export default component.exports